@if (hasAccess) {
<div class="row">
  <div class="col-lg-{{ showRightNav ? 9 : 12 }} mt-lg-0 mt-4">
    @if (isLoading) {
    <app-card-wrapper [hasIntro]="true">
      <h5 card-title>{{ isLoadingTitle }}</h5>
      <h5><i class="fas fa-circle-notch fa-spin me-2"></i></h5>
    </app-card-wrapper>
    }@else {
    <ng-content select="[body]"></ng-content>
    }
  </div>
  <div #rightNavBlock class="d-none d-lg-block {{ showRightNav ? 'col-lg-3' : '' }}">
    <ng-content *ngIf="showRightNav" select="[rightNav]"></ng-content>
  </div>
</div>
} @else {
<app-no-access [url]="noAccessWebinarUrl" [rubriek]="rubriek"></app-no-access>
}
